/* eslint-disable react-hooks/exhaustive-deps */
import deleteImg from "assets/pictures/delete.png";
import QuantityUpdate from "components/cart/QuantityUpdate";
import { CouponForm } from "components/coupon";
import Footer from "components/Footer";
import Header from "components/Header";
import { ProductCard, ProductQuery } from "components/products";
import { useCart } from "hooks";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { remove, removeDiscount } from "store/cart/actions";

const Cart = () => {
  const dispatch = useDispatch();
  const { items, subTotal, discount, coupon, totalQuantity } = useCart();
  const { data } = ProductQuery();
  const shop = useSelector((state) => state.shop);
  const [shippingCharge, setShippingCharge] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const category_arr = {};

  data.forEach((product) => {
    if (product?.category?.name) {
      category_arr[product.category.name] = product.category.id;
    }
  });

  useEffect(() => {
    if (totalQuantity === 0) {
      dispatch(removeDiscount());
    }

    if (subTotal > discount) {
      const myTotal = subTotal - discount;
      let shippingCost = 0;
      if (shop?.shipping_charges_enabled) {
        if (shop.free_shipping_limit && myTotal >= shop.free_shipping_limit) {
          shippingCost = 0;
        } else {
          shippingCost = parseFloat(shop.shipping_charges) || 0;
        }
      }
      setShippingCharge(shippingCost);
      setGrandTotal(myTotal + shippingCost);
    }
  }, [totalQuantity, subTotal, discount, shop]);

  const handleRemove = (id) => {
    dispatch(remove(id));
  };

  return (
    <Fragment>
      <Header />
      <div className="container-fluid">
        <div className="main-cart-section">
          <h1 className="pt-4 cart-heading">Cart</h1>
          <div className="row">
            <div className="col-lg-8">
              <div className="cart-section">
                {items.length > 0 ? (
                  items.map((item, idx) => (
                    <Fragment key={item.id}>
                      <div className="row cart-main align-items-center">
                        <div className="col-4 col-sm-3 col-md-3">
                          <img
                            src={item?.model?.image}
                            alt={item?.model?.name}
                            className="img-fluid cart-imagess"
                          />
                        </div>
                        <div className="col-8 col-sm-9 col-md-9">
                          <div className="head-price align-items-center">
                            <h5 className="mb-0">{item?.model?.name}</h5>
                            <h4 className="mb-0 me-5">₹{item?.price}</h4>
                          </div>
                          <div className="qunt-mains mt-3">
                            <div className="quantity d-flex align-items-center gap-3">
                              <QuantityUpdate
                                quantity={item?.quantity}
                                id={item?.id}
                                inventoryCount={item?.model?.inventory_count || 10}
                              />
                              <div className="delete-img">
                                <img
                                  src={deleteImg}
                                  alt="Delete"
                                  className="delete-icon"
                                  onClick={() => handleRemove(item?.id)}
                                />
                              </div>
                            </div>
                            <div className="quantity mt-3 d-flex align-items-center gap-2">
                              <h6 className="mb-0">Sub Total</h6>
                              <span>
                                ₹{Number(item?.quantity) * Number(item?.price)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {idx !== items.length - 1 && (
                        <div className="dashed-border my-3"></div>
                      )}
                    </Fragment>
                  ))
                ) : (
                  <p className="text-center">No product here</p>
                )}
              </div>
            </div>
            <div className="col-lg-4">
              {!discount && items.length !== 0 && <CouponForm />}
              {items.length > 0 && (
                <div className="total-section p-4">
                  <h1 className="mb-4 total-heading">
                    <u>Total</u>
                  </h1>
                  <div className="total-products">
                    {items.map((item) => (
                      <div
                        className="product-price d-flex justify-content-evenly"
                        key={item.id}
                      >
                        <h5>{item?.model?.name}</h5>
                        <span>
                          ₹{Number(item?.quantity) * Number(item?.price)}
                        </span>
                      </div>
                    ))}
                    <div className="product-price d-flex justify-content-between mt-2">
                      <h5>Discount</h5>
                      <span>₹{discount}</span>
                    </div>
                    {discount > 0 && (
                      <div className="d-flex align-items-center gap-2 mt-2">
                        <span className="coupon-code">{coupon?.code}</span>
                        <img
                          src={deleteImg}
                          alt="Remove Discount"
                          className="delete-icon"
                          onClick={() => dispatch(removeDiscount())}
                        />
                      </div>
                    )}
                    <div className="product-price d-flex justify-content-between">
                      <h5 className="subtotal-label">Grand Total</h5>
                      <span className="subtotal-amount">
                        ₹{Number(grandTotal) || 0}
                      </span>
                    </div>
                  </div>
                  <Link
                    to="/checkout"
                    className="payment-btn mt-4 d-block text-center"
                  >
                    Proceed to Payment
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer category={category_arr} />
      </div>
    </Fragment>
  );
};

export default Cart;
